import { t } from "i18next";
import Button from "@src/components/UIElements/Button/index";
import RightArrowIcon from "@src/components/AccentIcons/RightArrowIcon";
import DashBorder from "@src/components/UIElements/DashBorder";
import { Image } from "@src/components/Image";
import { addTokenInUrl, getAwsAssets, hitHapticFeedback } from "@src/utils";
import { useDispatch, useSelector } from "react-redux";
import { buyNowDoubtBuddyModalAction } from "@src/layout/store/actions";
import { hitContentDeeplinkOld } from "../../../Content/helpers/hitContentDeeplink";

const BundleListCard = ({ bundleData=[], isModal,meta ,handleShowModal=() => {}}) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state?.persistedDataReducer?.userToken);

  const bundleImages = {
    "TEST":getAwsAssets("testBook20062023.png", "Overview"),
    "BOOKS":getAwsAssets("Book20062023.png", "Overview"),
    "DOUBTBUDDY":getAwsAssets("doubtMate8aug2024.svg", "Overview"),
  }
  const handleDoubtBuddyCard = (items) => {
    if(meta?.isPurchased === 1) {
      hitContentDeeplinkOld("UTIL_WEBVIEW", {paramOne: addTokenInUrl(items?.doubtBuddyUrl, token)}, true, true)
    } else {
      handleShowModal()
      dispatch(buyNowDoubtBuddyModalAction(true))
    }
  }
  return (
      <div className="bundleBox">
        {bundleData?.map((items, i) => {
            return (<>
            {/* style={{ height : bundleData[i].courseType === "DOUBTBUDDY" ? "96px" : ""}} */}
              <div className="bundleListItem" key={i} style={{alignItems: bundleData[i].courseType === "DOUBTBUDDY" ? "start" : "center"}}>
                <div className="img-div" >
                  <Image
                    src={bundleImages[items?.courseType]}
                    height="40px"
                    width="40px"
                    alt={t(
                      "components.bottomSheets.components.applyBundleBottomSheet.couponlist",
                      "Bundlelist"
                    )}
                  />
                </div>
                <div className="content-div">
                  <p>{items?.courseName}</p>
                  {items?.courseType === "DOUBTBUDDY" ? 
                    <div className="doubt-extra">
                      <p className="descp">Get superfast solution to your doubts with explanation in 60 sec.</p>
                      <Button className="viewALLBtn" onClick={() => handleDoubtBuddyCard(items)}>
                        Let&apos;s try now &rarr;
                      </Button>
                    </div>
                  : null}
                </div>
              </div>
              { i < 2 ? <DashBorder sideMargins={16} inner /> : ""}
              </>
            );
        })}
      </div>
  );
};
export default BundleListCard;
